module.exports = __webpack_public_path__ + "static/img/wx1.87821ad.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/wx1.png
// module id = Mv9z
// module chunks = 1